export default [
  {
    n: '北京市',
    s: [
      {
        n: '北京市',
        c: [
          '东城区',
          '西城区',
          '朝阳区',
          '丰台区',
          '石景山区',
          '海淀区',
          '门头沟区',
          '房山区',
          '通州区',
          '顺义区',
          '昌平区',
          '大兴区',
          '怀柔区',
          '平谷区',
          '密云区',
          '延庆区'
        ]
      }
    ]
  },
  {
    n: '天津市',
    s: [
      {
        n: '天津市',
        c: [
          '和平区',
          '河东区',
          '河西区',
          '南开区',
          '河北区',
          '红桥区',
          '东丽区',
          '西青区',
          '津南区',
          '北辰区',
          '武清区',
          '宝坻区',
          '滨海新区',
          '宁河区',
          '静海区',
          '蓟州区'
        ]
      }
    ]
  },
  {
    n: '河北省',
    s: [
      {
        n: '石家庄市',
        c: [
          '长安区',
          '桥西区',
          '新华区',
          '井陉矿区',
          '裕华区',
          '藁城区',
          '鹿泉区',
          '栾城区',
          '井陉县',
          '正定县',
          '行唐县',
          '灵寿县',
          '高邑县',
          '深泽县',
          '赞皇县',
          '无极县',
          '平山县',
          '元氏县',
          '赵县',
          '辛集市',
          '晋州市',
          '新乐市'
        ]
      },
      {
        n: '唐山市',
        c: [
          '路南区',
          '路北区',
          '古冶区',
          '开平区',
          '丰南区',
          '丰润区',
          '曹妃甸区',
          '滦南县',
          '乐亭县',
          '迁西县',
          '玉田县',
          '遵化市',
          '迁安市',
          '滦州市'
        ]
      },
      {
        n: '秦皇岛市',
        c: [
          '海港区',
          '山海关区',
          '北戴河区',
          '抚宁区',
          '青龙满族自治县',
          '昌黎县',
          '卢龙县'
        ]
      },
      {
        n: '邯郸市',
        c: [
          '邯山区',
          '丛台区',
          '复兴区',
          '峰峰矿区',
          '肥乡区',
          '永年区',
          '临漳县',
          '成安县',
          '大名县',
          '涉县',
          '磁县',
          '邱县',
          '鸡泽县',
          '广平县',
          '馆陶县',
          '魏县',
          '曲周县',
          '武安市'
        ]
      },
      {
        n: '邢台市',
        c: [
          '襄都区',
          '信都区',
          '任泽区',
          '南和区',
          '临城县',
          '内丘县',
          '柏乡县',
          '隆尧县',
          '宁晋县',
          '巨鹿县',
          '新河县',
          '广宗县',
          '平乡县',
          '威县',
          '清河县',
          '临西县',
          '南宫市',
          '沙河市'
        ]
      },
      {
        n: '保定市',
        c: [
          '竞秀区',
          '莲池区',
          '满城区',
          '清苑区',
          '徐水区',
          '涞水县',
          '阜平县',
          '定兴县',
          '唐县',
          '高阳县',
          '容城县',
          '涞源县',
          '望都县',
          '安新县',
          '易县',
          '曲阳县',
          '蠡县',
          '顺平县',
          '博野县',
          '雄县',
          '涿州市',
          '定州市',
          '安国市',
          '高碑店市'
        ]
      },
      {
        n: '张家口市',
        c: [
          '桥东区',
          '桥西区',
          '宣化区',
          '下花园区',
          '万全区',
          '崇礼区',
          '张北县',
          '康保县',
          '沽源县',
          '尚义县',
          '蔚县',
          '阳原县',
          '怀安县',
          '怀来县',
          '涿鹿县',
          '赤城县'
        ]
      },
      {
        n: '承德市',
        c: [
          '双桥区',
          '双滦区',
          '鹰手营子矿区',
          '承德县',
          '兴隆县',
          '滦平县',
          '隆化县',
          '丰宁满族自治县',
          '宽城满族自治县',
          '围场满族蒙古族自治县',
          '平泉市'
        ]
      },
      {
        n: '沧州市',
        c: [
          '新华区',
          '运河区',
          '沧县',
          '青县',
          '东光县',
          '海兴县',
          '盐山县',
          '肃宁县',
          '南皮县',
          '吴桥县',
          '献县',
          '孟村回族自治县',
          '泊头市',
          '任丘市',
          '黄骅市',
          '河间市'
        ]
      },
      {
        n: '廊坊市',
        c: [
          '安次区',
          '广阳区',
          '固安县',
          '永清县',
          '香河县',
          '大城县',
          '文安县',
          '大厂回族自治县',
          '霸州市',
          '三河市'
        ]
      },
      {
        n: '衡水市',
        c: [
          '桃城区',
          '冀州区',
          '枣强县',
          '武邑县',
          '武强县',
          '饶阳县',
          '安平县',
          '故城县',
          '景县',
          '阜城县',
          '深州市'
        ]
      }
    ]
  },
  {
    n: '山西省',
    s: [
      {
        n: '太原市',
        c: [
          '小店区',
          '迎泽区',
          '杏花岭区',
          '尖草坪区',
          '万柏林区',
          '晋源区',
          '清徐县',
          '阳曲县',
          '娄烦县',
          '古交市'
        ]
      },
      {
        n: '大同市',
        c: [
          '新荣区',
          '平城区',
          '云冈区',
          '云州区',
          '阳高县',
          '天镇县',
          '广灵县',
          '灵丘县',
          '浑源县',
          '左云县'
        ]
      },
      {
        n: '阳泉市',
        c: ['城区', '矿区', '郊区', '平定县', '盂县']
      },
      {
        n: '长治市',
        c: [
          '潞州区',
          '上党区',
          '屯留区',
          '潞城区',
          '襄垣县',
          '平顺县',
          '黎城县',
          '壶关县',
          '长子县',
          '武乡县',
          '沁县',
          '沁源县'
        ]
      },
      {
        n: '晋城市',
        c: ['城区', '沁水县', '阳城县', '陵川县', '泽州县', '高平市']
      },
      {
        n: '朔州市',
        c: ['朔城区', '平鲁区', '山阴县', '应县', '右玉县', '怀仁市']
      },
      {
        n: '晋中市',
        c: [
          '榆次区',
          '太谷区',
          '榆社县',
          '左权县',
          '和顺县',
          '昔阳县',
          '寿阳县',
          '祁县',
          '平遥县',
          '灵石县',
          '介休市'
        ]
      },
      {
        n: '运城市',
        c: [
          '盐湖区',
          '临猗县',
          '万荣县',
          '闻喜县',
          '稷山县',
          '新绛县',
          '绛县',
          '垣曲县',
          '夏县',
          '平陆县',
          '芮城县',
          '永济市',
          '河津市'
        ]
      },
      {
        n: '忻州市',
        c: [
          '忻府区',
          '定襄县',
          '五台县',
          '代县',
          '繁峙县',
          '宁武县',
          '静乐县',
          '神池县',
          '五寨县',
          '岢岚县',
          '河曲县',
          '保德县',
          '偏关县',
          '原平市'
        ]
      },
      {
        n: '临汾市',
        c: [
          '尧都区',
          '曲沃县',
          '翼城县',
          '襄汾县',
          '洪洞县',
          '古县',
          '安泽县',
          '浮山县',
          '吉县',
          '乡宁县',
          '大宁县',
          '隰县',
          '永和县',
          '蒲县',
          '汾西县',
          '侯马市',
          '霍州市'
        ]
      },
      {
        n: '吕梁市',
        c: [
          '离石区',
          '文水县',
          '交城县',
          '兴县',
          '临县',
          '柳林县',
          '石楼县',
          '岚县',
          '方山县',
          '中阳县',
          '交口县',
          '孝义市',
          '汾阳市'
        ]
      }
    ]
  },
  {
    n: '内蒙古自治区',
    s: [
      {
        n: '呼和浩特市',
        c: [
          '新城区',
          '回民区',
          '玉泉区',
          '赛罕区',
          '土默特左旗',
          '托克托县',
          '和林格尔县',
          '清水河县',
          '武川县'
        ]
      },
      {
        n: '包头市',
        c: [
          '东河区',
          '昆都仑区',
          '青山区',
          '石拐区',
          '白云鄂博矿区',
          '九原区',
          '土默特右旗',
          '固阳县',
          '达尔罕茂明安联合旗'
        ]
      },
      {
        n: '乌海市',
        c: ['海勃湾区', '海南区', '乌达区']
      },
      {
        n: '赤峰市',
        c: [
          '红山区',
          '元宝山区',
          '松山区',
          '阿鲁科尔沁旗',
          '巴林左旗',
          '巴林右旗',
          '林西县',
          '克什克腾旗',
          '翁牛特旗',
          '喀喇沁旗',
          '宁城县',
          '敖汉旗'
        ]
      },
      {
        n: '通辽市',
        c: [
          '科尔沁区',
          '科尔沁左翼中旗',
          '科尔沁左翼后旗',
          '开鲁县',
          '库伦旗',
          '奈曼旗',
          '扎鲁特旗',
          '霍林郭勒市'
        ]
      },
      {
        n: '鄂尔多斯市',
        c: [
          '东胜区',
          '康巴什区',
          '达拉特旗',
          '准格尔旗',
          '鄂托克前旗',
          '鄂托克旗',
          '杭锦旗',
          '乌审旗',
          '伊金霍洛旗'
        ]
      },
      {
        n: '呼伦贝尔市',
        c: [
          '海拉尔区',
          '扎赉诺尔区',
          '阿荣旗',
          '莫力达瓦达斡尔族自治旗',
          '鄂伦春自治旗',
          '鄂温克族自治旗',
          '陈巴尔虎旗',
          '新巴尔虎左旗',
          '新巴尔虎右旗',
          '满洲里市',
          '牙克石市',
          '扎兰屯市',
          '额尔古纳市',
          '根河市'
        ]
      },
      {
        n: '巴彦淖尔市',
        c: [
          '临河区',
          '五原县',
          '磴口县',
          '乌拉特前旗',
          '乌拉特中旗',
          '乌拉特后旗',
          '杭锦后旗'
        ]
      },
      {
        n: '乌兰察布市',
        c: [
          '集宁区',
          '卓资县',
          '化德县',
          '商都县',
          '兴和县',
          '凉城县',
          '察哈尔右翼前旗',
          '察哈尔右翼中旗',
          '察哈尔右翼后旗',
          '四子王旗',
          '丰镇市'
        ]
      },
      {
        n: '兴安盟',
        c: [
          '乌兰浩特市',
          '阿尔山市',
          '科尔沁右翼前旗',
          '科尔沁右翼中旗',
          '扎赉特旗',
          '突泉县'
        ]
      },
      {
        n: '锡林郭勒盟',
        c: [
          '二连浩特市',
          '锡林浩特市',
          '阿巴嘎旗',
          '苏尼特左旗',
          '苏尼特右旗',
          '东乌珠穆沁旗',
          '西乌珠穆沁旗',
          '太仆寺旗',
          '镶黄旗',
          '正镶白旗',
          '正蓝旗',
          '多伦县'
        ]
      },
      {
        n: '阿拉善盟',
        c: ['阿拉善左旗', '阿拉善右旗', '额济纳旗']
      }
    ]
  },
  {
    n: '辽宁省',
    s: [
      {
        n: '沈阳市',
        c: [
          '和平区',
          '沈河区',
          '大东区',
          '皇姑区',
          '铁西区',
          '苏家屯区',
          '浑南区',
          '沈北新区',
          '于洪区',
          '辽中区',
          '康平县',
          '法库县',
          '新民市'
        ]
      },
      {
        n: '大连市',
        c: [
          '中山区',
          '西岗区',
          '沙河口区',
          '甘井子区',
          '旅顺口区',
          '金州区',
          '普兰店区',
          '长海县',
          '瓦房店市',
          '庄河市'
        ]
      },
      {
        n: '鞍山市',
        c: [
          '铁东区',
          '铁西区',
          '立山区',
          '千山区',
          '台安县',
          '岫岩满族自治县',
          '海城市'
        ]
      },
      {
        n: '抚顺市',
        c: [
          '新抚区',
          '东洲区',
          '望花区',
          '顺城区',
          '抚顺县',
          '新宾满族自治县',
          '清原满族自治县'
        ]
      },
      {
        n: '本溪市',
        c: [
          '平山区',
          '溪湖区',
          '明山区',
          '南芬区',
          '本溪满族自治县',
          '桓仁满族自治县'
        ]
      },
      {
        n: '丹东市',
        c: ['元宝区', '振兴区', '振安区', '宽甸满族自治县', '东港市', '凤城市']
      },
      {
        n: '锦州市',
        c: ['古塔区', '凌河区', '太和区', '黑山县', '义县', '凌海市', '北镇市']
      },
      {
        n: '营口市',
        c: ['站前区', '西市区', '鲅鱼圈区', '老边区', '盖州市', '大石桥市']
      },
      {
        n: '阜新市',
        c: [
          '海州区',
          '新邱区',
          '太平区',
          '清河门区',
          '细河区',
          '阜新蒙古族自治县',
          '彰武县'
        ]
      },
      {
        n: '辽阳市',
        c: [
          '白塔区',
          '文圣区',
          '宏伟区',
          '弓长岭区',
          '太子河区',
          '辽阳县',
          '灯塔市'
        ]
      },
      {
        n: '盘锦市',
        c: ['双台子区', '兴隆台区', '大洼区', '盘山县']
      },
      {
        n: '铁岭市',
        c: [
          '银州区',
          '清河区',
          '铁岭县',
          '西丰县',
          '昌图县',
          '调兵山市',
          '开原市'
        ]
      },
      {
        n: '朝阳市',
        c: [
          '双塔区',
          '龙城区',
          '朝阳县',
          '建平县',
          '喀喇沁左翼蒙古族自治县',
          '北票市',
          '凌源市'
        ]
      },
      {
        n: '葫芦岛市',
        c: ['连山区', '龙港区', '南票区', '绥中县', '建昌县', '兴城市']
      }
    ]
  },
  {
    n: '吉林省',
    s: [
      {
        n: '长春市',
        c: [
          '南关区',
          '宽城区',
          '朝阳区',
          '二道区',
          '绿园区',
          '双阳区',
          '九台区',
          '农安县',
          '榆树市',
          '德惠市',
          '公主岭市'
        ]
      },
      {
        n: '吉林市',
        c: [
          '昌邑区',
          '龙潭区',
          '船营区',
          '丰满区',
          '永吉县',
          '蛟河市',
          '桦甸市',
          '舒兰市',
          '磐石市'
        ]
      },
      {
        n: '四平市',
        c: ['铁西区', '铁东区', '梨树县', '伊通满族自治县', '双辽市']
      },
      {
        n: '辽源市',
        c: ['龙山区', '西安区', '东丰县', '东辽县']
      },
      {
        n: '通化市',
        c: [
          '东昌区',
          '二道江区',
          '通化县',
          '辉南县',
          '柳河县',
          '梅河口市',
          '集安市'
        ]
      },
      {
        n: '白山市',
        c: [
          '浑江区',
          '江源区',
          '抚松县',
          '靖宇县',
          '长白朝鲜族自治县',
          '临江市'
        ]
      },
      {
        n: '松原市',
        c: ['宁江区', '前郭尔罗斯蒙古族自治县', '长岭县', '乾安县', '扶余市']
      },
      {
        n: '白城市',
        c: ['洮北区', '镇赉县', '通榆县', '洮南市', '大安市']
      },
      {
        n: '延边朝鲜族自治州',
        c: [
          '延吉市',
          '图们市',
          '敦化市',
          '珲春市',
          '龙井市',
          '和龙市',
          '汪清县',
          '安图县'
        ]
      }
    ]
  },
  {
    n: '黑龙江省',
    s: [
      {
        n: '哈尔滨市',
        c: [
          '道里区',
          '南岗区',
          '道外区',
          '平房区',
          '松北区',
          '香坊区',
          '呼兰区',
          '阿城区',
          '双城区',
          '依兰县',
          '方正县',
          '宾县',
          '巴彦县',
          '木兰县',
          '通河县',
          '延寿县',
          '尚志市',
          '五常市'
        ]
      },
      {
        n: '齐齐哈尔市',
        c: [
          '龙沙区',
          '建华区',
          '铁锋区',
          '昂昂溪区',
          '富拉尔基区',
          '碾子山区',
          '梅里斯达斡尔族区',
          '龙江县',
          '依安县',
          '泰来县',
          '甘南县',
          '富裕县',
          '克山县',
          '克东县',
          '拜泉县',
          '讷河市'
        ]
      },
      {
        n: '鸡西市',
        c: [
          '鸡冠区',
          '恒山区',
          '滴道区',
          '梨树区',
          '城子河区',
          '麻山区',
          '鸡东县',
          '虎林市',
          '密山市'
        ]
      },
      {
        n: '鹤岗市',
        c: [
          '向阳区',
          '工农区',
          '南山区',
          '兴安区',
          '东山区',
          '兴山区',
          '萝北县',
          '绥滨县'
        ]
      },
      {
        n: '双鸭山市',
        c: [
          '尖山区',
          '岭东区',
          '四方台区',
          '宝山区',
          '集贤县',
          '友谊县',
          '宝清县',
          '饶河县'
        ]
      },
      {
        n: '大庆市',
        c: [
          '萨尔图区',
          '龙凤区',
          '让胡路区',
          '红岗区',
          '大同区',
          '肇州县',
          '肇源县',
          '林甸县',
          '杜尔伯特蒙古族自治县'
        ]
      },
      {
        n: '伊春市',
        c: [
          '伊美区',
          '乌翠区',
          '友好区',
          '嘉荫县',
          '汤旺县',
          '丰林县',
          '大箐山县',
          '南岔县',
          '金林区',
          '铁力市'
        ]
      },
      {
        n: '佳木斯市',
        c: [
          '向阳区',
          '前进区',
          '东风区',
          '郊区',
          '桦南县',
          '桦川县',
          '汤原县',
          '同江市',
          '富锦市',
          '抚远市'
        ]
      },
      {
        n: '七台河市',
        c: ['新兴区', '桃山区', '茄子河区', '勃利县']
      },
      {
        n: '牡丹江市',
        c: [
          '东安区',
          '阳明区',
          '爱民区',
          '西安区',
          '林口县',
          '绥芬河市',
          '海林市',
          '宁安市',
          '穆棱市',
          '东宁市'
        ]
      },
      {
        n: '黑河市',
        c: ['爱辉区', '逊克县', '孙吴县', '北安市', '五大连池市', '嫩江市']
      },
      {
        n: '绥化市',
        c: [
          '北林区',
          '望奎县',
          '兰西县',
          '青冈县',
          '庆安县',
          '明水县',
          '绥棱县',
          '安达市',
          '肇东市',
          '海伦市'
        ]
      },
      {
        n: '大兴安岭地区',
        c: ['漠河市', '加格达奇区', '呼玛县', '塔河县']
      }
    ]
  },
  {
    n: '上海市',
    s: [
      {
        n: '上海市',
        c: [
          '黄浦区',
          '徐汇区',
          '长宁区',
          '静安区',
          '普陀区',
          '虹口区',
          '杨浦区',
          '闵行区',
          '宝山区',
          '嘉定区',
          '浦东新区',
          '金山区',
          '松江区',
          '青浦区',
          '奉贤区',
          '崇明区'
        ]
      }
    ]
  },
  {
    n: '江苏省',
    s: [
      {
        n: '南京市',
        c: [
          '玄武区',
          '秦淮区',
          '建邺区',
          '鼓楼区',
          '浦口区',
          '栖霞区',
          '雨花台区',
          '江宁区',
          '六合区',
          '溧水区',
          '高淳区'
        ]
      },
      {
        n: '无锡市',
        c: [
          '锡山区',
          '惠山区',
          '滨湖区',
          '梁溪区',
          '新吴区',
          '江阴市',
          '宜兴市'
        ]
      },
      {
        n: '徐州市',
        c: [
          '鼓楼区',
          '云龙区',
          '贾汪区',
          '泉山区',
          '铜山区',
          '丰县',
          '沛县',
          '睢宁县',
          '新沂市',
          '邳州市'
        ]
      },
      {
        n: '常州市',
        c: ['天宁区', '钟楼区', '新北区', '武进区', '金坛区', '溧阳市']
      },
      {
        n: '苏州市',
        c: [
          '虎丘区',
          '吴中区',
          '相城区',
          '姑苏区',
          '吴江区',
          '常熟市',
          '张家港市',
          '昆山市',
          '太仓市'
        ]
      },
      {
        n: '南通市',
        c: [
          '通州区',
          '崇川区',
          '海门区',
          '如东县',
          '启东市',
          '如皋市',
          '海安市'
        ]
      },
      {
        n: '连云港市',
        c: ['连云区', '海州区', '赣榆区', '东海县', '灌云县', '灌南县']
      },
      {
        n: '淮安市',
        c: [
          '淮安区',
          '淮阴区',
          '清江浦区',
          '洪泽区',
          '涟水县',
          '盱眙县',
          '金湖县'
        ]
      },
      {
        n: '盐城市',
        c: [
          '亭湖区',
          '盐都区',
          '大丰区',
          '响水县',
          '滨海县',
          '阜宁县',
          '射阳县',
          '建湖县',
          '东台市'
        ]
      },
      {
        n: '扬州市',
        c: ['广陵区', '邗江区', '江都区', '宝应县', '仪征市', '高邮市']
      },
      {
        n: '镇江市',
        c: ['京口区', '润州区', '丹徒区', '丹阳市', '扬中市', '句容市']
      },
      {
        n: '泰州市',
        c: ['海陵区', '高港区', '姜堰区', '兴化市', '靖江市', '泰兴市']
      },
      {
        n: '宿迁市',
        c: ['宿城区', '宿豫区', '沭阳县', '泗阳县', '泗洪县']
      }
    ]
  },
  {
    n: '浙江省',
    s: [
      {
        n: '杭州市',
        c: [
          '上城区',
          '拱墅区',
          '西湖区',
          '滨江区',
          '萧山区',
          '余杭区',
          '富阳区',
          '临安区',
          '临平区',
          '钱塘区',
          '桐庐县',
          '淳安县',
          '建德市'
        ]
      },
      {
        n: '宁波市',
        c: [
          '海曙区',
          '江北区',
          '北仑区',
          '镇海区',
          '鄞州区',
          '奉化区',
          '象山县',
          '宁海县',
          '余姚市',
          '慈溪市'
        ]
      },
      {
        n: '温州市',
        c: [
          '鹿城区',
          '龙湾区',
          '瓯海区',
          '洞头区',
          '永嘉县',
          '平阳县',
          '苍南县',
          '文成县',
          '泰顺县',
          '瑞安市',
          '乐清市',
          '龙港市'
        ]
      },
      {
        n: '嘉兴市',
        c: [
          '南湖区',
          '秀洲区',
          '嘉善县',
          '海盐县',
          '海宁市',
          '平湖市',
          '桐乡市'
        ]
      },
      {
        n: '湖州市',
        c: ['吴兴区', '南浔区', '德清县', '长兴县', '安吉县']
      },
      {
        n: '绍兴市',
        c: ['越城区', '柯桥区', '上虞区', '新昌县', '诸暨市', '嵊州市']
      },
      {
        n: '金华市',
        c: [
          '婺城区',
          '金东区',
          '武义县',
          '浦江县',
          '磐安县',
          '兰溪市',
          '义乌市',
          '东阳市',
          '永康市'
        ]
      },
      {
        n: '衢州市',
        c: ['柯城区', '衢江区', '常山县', '开化县', '龙游县', '江山市']
      },
      {
        n: '舟山市',
        c: ['定海区', '普陀区', '岱山县', '嵊泗县']
      },
      {
        n: '台州市',
        c: [
          '椒江区',
          '黄岩区',
          '路桥区',
          '三门县',
          '天台县',
          '仙居县',
          '温岭市',
          '临海市',
          '玉环市'
        ]
      },
      {
        n: '丽水市',
        c: [
          '莲都区',
          '青田县',
          '缙云县',
          '遂昌县',
          '松阳县',
          '云和县',
          '庆元县',
          '景宁畲族自治县',
          '龙泉市'
        ]
      }
    ]
  },
  {
    n: '安徽省',
    s: [
      {
        n: '合肥市',
        c: [
          '瑶海区',
          '庐阳区',
          '蜀山区',
          '包河区',
          '长丰县',
          '肥东县',
          '肥西县',
          '庐江县',
          '巢湖市'
        ]
      },
      {
        n: '芜湖市',
        c: [
          '镜湖区',
          '鸠江区',
          '弋江区',
          '湾沚区',
          '繁昌区',
          '南陵县',
          '无为市'
        ]
      },
      {
        n: '蚌埠市',
        c: [
          '龙子湖区',
          '蚌山区',
          '禹会区',
          '淮上区',
          '怀远县',
          '五河县',
          '固镇县'
        ]
      },
      {
        n: '淮南市',
        c: [
          '大通区',
          '田家庵区',
          '谢家集区',
          '八公山区',
          '潘集区',
          '凤台县',
          '寿县'
        ]
      },
      {
        n: '马鞍山市',
        c: ['花山区', '雨山区', '博望区', '当涂县', '含山县', '和县']
      },
      {
        n: '淮北市',
        c: ['杜集区', '相山区', '烈山区', '濉溪县']
      },
      {
        n: '铜陵市',
        c: ['铜官区', '义安区', '郊区', '枞阳县']
      },
      {
        n: '安庆市',
        c: [
          '迎江区',
          '大观区',
          '宜秀区',
          '怀宁县',
          '太湖县',
          '宿松县',
          '望江县',
          '岳西县',
          '桐城市',
          '潜山市'
        ]
      },
      {
        n: '黄山市',
        c: ['屯溪区', '黄山区', '徽州区', '歙县', '休宁县', '黟县', '祁门县']
      },
      {
        n: '滁州市',
        c: [
          '琅琊区',
          '南谯区',
          '来安县',
          '全椒县',
          '定远县',
          '凤阳县',
          '天长市',
          '明光市'
        ]
      },
      {
        n: '阜阳市',
        c: [
          '颍州区',
          '颍东区',
          '颍泉区',
          '临泉县',
          '太和县',
          '阜南县',
          '颍上县',
          '界首市'
        ]
      },
      {
        n: '宿州市',
        c: ['埇桥区', '砀山县', '萧县', '灵璧县', '泗县']
      },
      {
        n: '六安市',
        c: [
          '金安区',
          '裕安区',
          '叶集区',
          '霍邱县',
          '舒城县',
          '金寨县',
          '霍山县'
        ]
      },
      {
        n: '亳州市',
        c: ['谯城区', '涡阳县', '蒙城县', '利辛县']
      },
      {
        n: '池州市',
        c: ['贵池区', '东至县', '石台县', '青阳县']
      },
      {
        n: '宣城市',
        c: ['宣州区', '郎溪县', '泾县', '绩溪县', '旌德县', '宁国市', '广德市']
      }
    ]
  },
  {
    n: '福建省',
    s: [
      {
        n: '福州市',
        c: [
          '鼓楼区',
          '台江区',
          '仓山区',
          '马尾区',
          '晋安区',
          '长乐区',
          '闽侯县',
          '连江县',
          '罗源县',
          '闽清县',
          '永泰县',
          '平潭县',
          '福清市'
        ]
      },
      {
        n: '厦门市',
        c: ['思明区', '海沧区', '湖里区', '集美区', '同安区', '翔安区']
      },
      {
        n: '莆田市',
        c: ['城厢区', '涵江区', '荔城区', '秀屿区', '仙游县']
      },
      {
        n: '三明市',
        c: [
          '三元区',
          '沙县区',
          '明溪县',
          '清流县',
          '宁化县',
          '大田县',
          '尤溪县',
          '将乐县',
          '泰宁县',
          '建宁县',
          '永安市'
        ]
      },
      {
        n: '泉州市',
        c: [
          '鲤城区',
          '丰泽区',
          '洛江区',
          '泉港区',
          '惠安县',
          '安溪县',
          '永春县',
          '德化县',
          '金门县',
          '石狮市',
          '晋江市',
          '南安市'
        ]
      },
      {
        n: '漳州市',
        c: [
          '芗城区',
          '龙文区',
          '龙海区',
          '长泰区',
          '云霄县',
          '漳浦县',
          '诏安县',
          '东山县',
          '南靖县',
          '平和县',
          '华安县'
        ]
      },
      {
        n: '南平市',
        c: [
          '延平区',
          '建阳区',
          '顺昌县',
          '浦城县',
          '光泽县',
          '松溪县',
          '政和县',
          '邵武市',
          '武夷山市',
          '建瓯市'
        ]
      },
      {
        n: '龙岩市',
        c: [
          '新罗区',
          '永定区',
          '长汀县',
          '上杭县',
          '武平县',
          '连城县',
          '漳平市'
        ]
      },
      {
        n: '宁德市',
        c: [
          '蕉城区',
          '霞浦县',
          '古田县',
          '屏南县',
          '寿宁县',
          '周宁县',
          '柘荣县',
          '福安市',
          '福鼎市'
        ]
      }
    ]
  },
  {
    n: '江西省',
    s: [
      {
        n: '南昌市',
        c: [
          '东湖区',
          '西湖区',
          '青云谱区',
          '青山湖区',
          '新建区',
          '红谷滩区',
          '南昌县',
          '安义县',
          '进贤县'
        ]
      },
      {
        n: '景德镇市',
        c: ['昌江区', '珠山区', '浮梁县', '乐平市']
      },
      {
        n: '萍乡市',
        c: ['安源区', '湘东区', '莲花县', '上栗县', '芦溪县']
      },
      {
        n: '九江市',
        c: [
          '濂溪区',
          '浔阳区',
          '柴桑区',
          '武宁县',
          '修水县',
          '永修县',
          '德安县',
          '都昌县',
          '湖口县',
          '彭泽县',
          '瑞昌市',
          '共青城市',
          '庐山市'
        ]
      },
      {
        n: '新余市',
        c: ['渝水区', '分宜县']
      },
      {
        n: '鹰潭市',
        c: ['月湖区', '余江区', '贵溪市']
      },
      {
        n: '赣州市',
        c: [
          '章贡区',
          '南康区',
          '赣县区',
          '信丰县',
          '大余县',
          '上犹县',
          '崇义县',
          '安远县',
          '定南县',
          '全南县',
          '宁都县',
          '于都县',
          '兴国县',
          '会昌县',
          '寻乌县',
          '石城县',
          '瑞金市',
          '龙南市'
        ]
      },
      {
        n: '吉安市',
        c: [
          '吉州区',
          '青原区',
          '吉安县',
          '吉水县',
          '峡江县',
          '新干县',
          '永丰县',
          '泰和县',
          '遂川县',
          '万安县',
          '安福县',
          '永新县',
          '井冈山市'
        ]
      },
      {
        n: '宜春市',
        c: [
          '袁州区',
          '奉新县',
          '万载县',
          '上高县',
          '宜丰县',
          '靖安县',
          '铜鼓县',
          '丰城市',
          '樟树市',
          '高安市'
        ]
      },
      {
        n: '抚州市',
        c: [
          '临川区',
          '东乡区',
          '南城县',
          '黎川县',
          '南丰县',
          '崇仁县',
          '乐安县',
          '宜黄县',
          '金溪县',
          '资溪县',
          '广昌县'
        ]
      },
      {
        n: '上饶市',
        c: [
          '信州区',
          '广丰区',
          '广信区',
          '玉山县',
          '铅山县',
          '横峰县',
          '弋阳县',
          '余干县',
          '鄱阳县',
          '万年县',
          '婺源县',
          '德兴市'
        ]
      }
    ]
  },
  {
    n: '山东省',
    s: [
      {
        n: '济南市',
        c: [
          '历下区',
          '市中区',
          '槐荫区',
          '天桥区',
          '历城区',
          '长清区',
          '章丘区',
          '济阳区',
          '莱芜区',
          '钢城区',
          '平阴县',
          '商河县'
        ]
      },
      {
        n: '青岛市',
        c: [
          '市南区',
          '市北区',
          '黄岛区',
          '崂山区',
          '李沧区',
          '城阳区',
          '即墨区',
          '胶州市',
          '平度市',
          '莱西市'
        ]
      },
      {
        n: '淄博市',
        c: [
          '淄川区',
          '张店区',
          '博山区',
          '临淄区',
          '周村区',
          '桓台县',
          '高青县',
          '沂源县'
        ]
      },
      {
        n: '枣庄市',
        c: ['市中区', '薛城区', '峄城区', '台儿庄区', '山亭区', '滕州市']
      },
      {
        n: '东营市',
        c: ['东营区', '河口区', '垦利区', '利津县', '广饶县']
      },
      {
        n: '烟台市',
        c: [
          '芝罘区',
          '福山区',
          '牟平区',
          '莱山区',
          '蓬莱区',
          '龙口市',
          '莱阳市',
          '莱州市',
          '招远市',
          '栖霞市',
          '海阳市'
        ]
      },
      {
        n: '潍坊市',
        c: [
          '潍城区',
          '寒亭区',
          '坊子区',
          '奎文区',
          '临朐县',
          '昌乐县',
          '青州市',
          '诸城市',
          '寿光市',
          '安丘市',
          '高密市',
          '昌邑市'
        ]
      },
      {
        n: '济宁市',
        c: [
          '任城区',
          '兖州区',
          '微山县',
          '鱼台县',
          '金乡县',
          '嘉祥县',
          '汶上县',
          '泗水县',
          '梁山县',
          '曲阜市',
          '邹城市'
        ]
      },
      {
        n: '泰安市',
        c: ['泰山区', '岱岳区', '宁阳县', '东平县', '新泰市', '肥城市']
      },
      {
        n: '威海市',
        c: ['环翠区', '文登区', '荣成市', '乳山市']
      },
      {
        n: '日照市',
        c: ['东港区', '岚山区', '五莲县', '莒县']
      },
      {
        n: '临沂市',
        c: [
          '兰山区',
          '罗庄区',
          '河东区',
          '沂南县',
          '郯城县',
          '沂水县',
          '兰陵县',
          '费县',
          '平邑县',
          '莒南县',
          '蒙阴县',
          '临沭县'
        ]
      },
      {
        n: '德州市',
        c: [
          '德城区',
          '陵城区',
          '宁津县',
          '庆云县',
          '临邑县',
          '齐河县',
          '平原县',
          '夏津县',
          '武城县',
          '乐陵市',
          '禹城市'
        ]
      },
      {
        n: '聊城市',
        c: [
          '东昌府区',
          '茌平区',
          '阳谷县',
          '莘县',
          '东阿县',
          '冠县',
          '高唐县',
          '临清市'
        ]
      },
      {
        n: '滨州市',
        c: [
          '滨城区',
          '沾化区',
          '惠民县',
          '阳信县',
          '无棣县',
          '博兴县',
          '邹平市'
        ]
      },
      {
        n: '菏泽市',
        c: [
          '牡丹区',
          '定陶区',
          '曹县',
          '单县',
          '成武县',
          '巨野县',
          '郓城县',
          '鄄城县',
          '东明县'
        ]
      }
    ]
  },
  {
    n: '河南省',
    s: [
      {
        n: '郑州市',
        c: [
          '中原区',
          '二七区',
          '管城回族区',
          '金水区',
          '上街区',
          '惠济区',
          '中牟县',
          '巩义市',
          '荥阳市',
          '新密市',
          '新郑市',
          '登封市'
        ]
      },
      {
        n: '开封市',
        c: [
          '龙亭区',
          '顺河回族区',
          '鼓楼区',
          '禹王台区',
          '祥符区',
          '杞县',
          '通许县',
          '尉氏县',
          '兰考县'
        ]
      },
      {
        n: '洛阳市',
        c: [
          '老城区',
          '西工区',
          '瀍河回族区',
          '涧西区',
          '偃师区',
          '孟津区',
          '洛龙区',
          '新安县',
          '栾川县',
          '嵩县',
          '汝阳县',
          '宜阳县',
          '洛宁县',
          '伊川县'
        ]
      },
      {
        n: '平顶山市',
        c: [
          '新华区',
          '卫东区',
          '石龙区',
          '湛河区',
          '宝丰县',
          '叶县',
          '鲁山县',
          '郏县',
          '舞钢市',
          '汝州市'
        ]
      },
      {
        n: '安阳市',
        c: [
          '文峰区',
          '北关区',
          '殷都区',
          '龙安区',
          '安阳县',
          '汤阴县',
          '滑县',
          '内黄县',
          '林州市'
        ]
      },
      {
        n: '鹤壁市',
        c: ['鹤山区', '山城区', '淇滨区', '浚县', '淇县']
      },
      {
        n: '新乡市',
        c: [
          '红旗区',
          '卫滨区',
          '凤泉区',
          '牧野区',
          '新乡县',
          '获嘉县',
          '原阳县',
          '延津县',
          '封丘县',
          '卫辉市',
          '辉县市',
          '长垣市'
        ]
      },
      {
        n: '焦作市',
        c: [
          '解放区',
          '中站区',
          '马村区',
          '山阳区',
          '修武县',
          '博爱县',
          '武陟县',
          '温县',
          '沁阳市',
          '孟州市'
        ]
      },
      {
        n: '濮阳市',
        c: ['华龙区', '清丰县', '南乐县', '范县', '台前县', '濮阳县']
      },
      {
        n: '许昌市',
        c: ['魏都区', '建安区', '鄢陵县', '襄城县', '禹州市', '长葛市']
      },
      {
        n: '漯河市',
        c: ['源汇区', '郾城区', '召陵区', '舞阳县', '临颍县']
      },
      {
        n: '三门峡市',
        c: ['湖滨区', '陕州区', '渑池县', '卢氏县', '义马市', '灵宝市']
      },
      {
        n: '南阳市',
        c: [
          '宛城区',
          '卧龙区',
          '南召县',
          '方城县',
          '西峡县',
          '镇平县',
          '内乡县',
          '淅川县',
          '社旗县',
          '唐河县',
          '新野县',
          '桐柏县',
          '邓州市'
        ]
      },
      {
        n: '商丘市',
        c: [
          '梁园区',
          '睢阳区',
          '民权县',
          '睢县',
          '宁陵县',
          '柘城县',
          '虞城县',
          '夏邑县',
          '永城市'
        ]
      },
      {
        n: '信阳市',
        c: [
          '浉河区',
          '平桥区',
          '罗山县',
          '光山县',
          '新县',
          '商城县',
          '固始县',
          '潢川县',
          '淮滨县',
          '息县'
        ]
      },
      {
        n: '周口市',
        c: [
          '川汇区',
          '淮阳区',
          '扶沟县',
          '西华县',
          '商水县',
          '沈丘县',
          '郸城县',
          '太康县',
          '鹿邑县',
          '项城市'
        ]
      },
      {
        n: '驻马店市',
        c: [
          '驿城区',
          '西平县',
          '上蔡县',
          '平舆县',
          '正阳县',
          '确山县',
          '泌阳县',
          '汝南县',
          '遂平县',
          '新蔡县'
        ]
      },
      {
        n: '济源市',
        c: [
          '坡头镇',
          '梨林镇',
          '思礼镇',
          '五龙口镇',
          '王屋镇',
          '玉泉街道',
          '轵城镇',
          '济水街道',
          '沁园街道',
          '下冶镇',
          '克井镇',
          '天坛街道',
          '邵原镇',
          '北海街道',
          '承留镇',
          '大峪镇'
        ]
      }
    ]
  },
  {
    n: '湖北省',
    s: [
      {
        n: '武汉市',
        c: [
          '江岸区',
          '江汉区',
          '硚口区',
          '汉阳区',
          '武昌区',
          '青山区',
          '洪山区',
          '东西湖区',
          '汉南区',
          '蔡甸区',
          '江夏区',
          '黄陂区',
          '新洲区'
        ]
      },
      {
        n: '黄石市',
        c: ['黄石港区', '西塞山区', '下陆区', '铁山区', '阳新县', '大冶市']
      },
      {
        n: '十堰市',
        c: [
          '茅箭区',
          '张湾区',
          '郧阳区',
          '郧西县',
          '竹山县',
          '竹溪县',
          '房县',
          '丹江口市'
        ]
      },
      {
        n: '宜昌市',
        c: [
          '西陵区',
          '伍家岗区',
          '点军区',
          '猇亭区',
          '夷陵区',
          '远安县',
          '兴山县',
          '秭归县',
          '长阳土家族自治县',
          '五峰土家族自治县',
          '宜都市',
          '当阳市',
          '枝江市'
        ]
      },
      {
        n: '襄阳市',
        c: [
          '襄城区',
          '樊城区',
          '襄州区',
          '南漳县',
          '谷城县',
          '保康县',
          '老河口市',
          '枣阳市',
          '宜城市'
        ]
      },
      {
        n: '鄂州市',
        c: ['梁子湖区', '华容区', '鄂城区']
      },
      {
        n: '荆门市',
        c: ['东宝区', '掇刀区', '沙洋县', '钟祥市', '京山市']
      },
      {
        n: '孝感市',
        c: [
          '孝南区',
          '孝昌县',
          '大悟县',
          '云梦县',
          '应城市',
          '安陆市',
          '汉川市'
        ]
      },
      {
        n: '荆州市',
        c: [
          '沙市区',
          '荆州区',
          '公安县',
          '江陵县',
          '石首市',
          '洪湖市',
          '松滋市',
          '监利市'
        ]
      },
      {
        n: '黄冈市',
        c: [
          '黄州区',
          '团风县',
          '红安县',
          '罗田县',
          '英山县',
          '浠水县',
          '蕲春县',
          '黄梅县',
          '麻城市',
          '武穴市'
        ]
      },
      {
        n: '咸宁市',
        c: ['咸安区', '嘉鱼县', '通城县', '崇阳县', '通山县', '赤壁市']
      },
      {
        n: '随州市',
        c: ['曾都区', '随县', '广水市']
      },
      {
        n: '恩施土家族苗族自治州',
        c: [
          '恩施市',
          '利川市',
          '建始县',
          '巴东县',
          '宣恩县',
          '咸丰县',
          '来凤县',
          '鹤峰县'
        ]
      },
      {
        n: '仙桃市',
        c: [
          '通海口镇',
          '胡场镇',
          '干河街道',
          '杨林尾镇',
          '彭场镇',
          '沔城回族镇',
          '龙华山街道',
          '沙湖原种场',
          '郑场镇',
          '排湖风景区',
          '郭河镇',
          '沙嘴街道',
          '张沟镇',
          '毛嘴镇',
          '三伏潭镇',
          '西流河镇',
          '五湖渔场',
          '长埫口镇',
          '杜湖街道',
          '沙湖镇',
          '剅河镇',
          '陈场镇'
        ]
      },
      {
        n: '潜江市',
        c: [
          '泰丰街道',
          '广华寺街道',
          '周矶管理区',
          '高场街道',
          '总口管理区',
          '运粮湖管理区',
          '王场镇',
          '园林街道',
          '白鹭湖管理区',
          '竹根滩镇',
          '渔洋镇',
          '熊口镇',
          '熊口管理区',
          '后湖管理区',
          '张金镇',
          '杨市街道',
          '周矶街道',
          '高石碑镇',
          '积玉口镇',
          '泽口街道',
          '浩口镇',
          '老新镇',
          '龙湾镇'
        ]
      },
      {
        n: '天门市',
        c: [
          '胡市镇',
          '黄潭镇',
          '多祥镇',
          '沉湖管委会',
          '干驿镇',
          '横林镇',
          '马湾镇',
          '蒋湖农场',
          '小板镇',
          '岳口镇',
          '蒋场镇',
          '石家河镇',
          '彭市镇',
          '佛子山镇',
          '九真镇',
          '竟陵街道',
          '侯口街道',
          '麻洋镇',
          '杨林街道',
          '汪场镇',
          '白茅湖农场',
          '皂市镇',
          '拖市镇',
          '净潭乡',
          '卢市镇',
          '多宝镇',
          '张港镇',
          '渔薪镇'
        ]
      },
      {
        n: '神农架林区',
        c: [
          '木鱼镇',
          '新华镇',
          '宋洛乡',
          '红坪镇',
          '松柏镇',
          '阳日镇',
          '大九湖镇',
          '下谷坪土家族乡'
        ]
      }
    ]
  },
  {
    n: '湖南省',
    s: [
      {
        n: '长沙市',
        c: [
          '芙蓉区',
          '天心区',
          '岳麓区',
          '开福区',
          '雨花区',
          '望城区',
          '长沙县',
          '浏阳市',
          '宁乡市'
        ]
      },
      {
        n: '株洲市',
        c: [
          '荷塘区',
          '芦淞区',
          '石峰区',
          '天元区',
          '渌口区',
          '攸县',
          '茶陵县',
          '炎陵县',
          '醴陵市'
        ]
      },
      {
        n: '湘潭市',
        c: ['雨湖区', '岳塘区', '湘潭县', '湘乡市', '韶山市']
      },
      {
        n: '衡阳市',
        c: [
          '珠晖区',
          '雁峰区',
          '石鼓区',
          '蒸湘区',
          '南岳区',
          '衡阳县',
          '衡南县',
          '衡山县',
          '衡东县',
          '祁东县',
          '耒阳市',
          '常宁市'
        ]
      },
      {
        n: '邵阳市',
        c: [
          '双清区',
          '大祥区',
          '北塔区',
          '新邵县',
          '邵阳县',
          '隆回县',
          '洞口县',
          '绥宁县',
          '新宁县',
          '城步苗族自治县',
          '武冈市',
          '邵东市'
        ]
      },
      {
        n: '岳阳市',
        c: [
          '岳阳楼区',
          '云溪区',
          '君山区',
          '岳阳县',
          '华容县',
          '湘阴县',
          '平江县',
          '汨罗市',
          '临湘市'
        ]
      },
      {
        n: '常德市',
        c: [
          '武陵区',
          '鼎城区',
          '安乡县',
          '汉寿县',
          '澧县',
          '临澧县',
          '桃源县',
          '石门县',
          '津市市'
        ]
      },
      {
        n: '张家界市',
        c: ['永定区', '武陵源区', '慈利县', '桑植县']
      },
      {
        n: '益阳市',
        c: ['资阳区', '赫山区', '南县', '桃江县', '安化县', '沅江市']
      },
      {
        n: '郴州市',
        c: [
          '北湖区',
          '苏仙区',
          '桂阳县',
          '宜章县',
          '永兴县',
          '嘉禾县',
          '临武县',
          '汝城县',
          '桂东县',
          '安仁县',
          '资兴市'
        ]
      },
      {
        n: '永州市',
        c: [
          '零陵区',
          '冷水滩区',
          '东安县',
          '双牌县',
          '道县',
          '江永县',
          '宁远县',
          '蓝山县',
          '新田县',
          '江华瑶族自治县',
          '祁阳市'
        ]
      },
      {
        n: '怀化市',
        c: [
          '鹤城区',
          '中方县',
          '沅陵县',
          '辰溪县',
          '溆浦县',
          '会同县',
          '麻阳苗族自治县',
          '新晃侗族自治县',
          '芷江侗族自治县',
          '靖州苗族侗族自治县',
          '通道侗族自治县',
          '洪江市'
        ]
      },
      {
        n: '娄底市',
        c: ['娄星区', '双峰县', '新化县', '冷水江市', '涟源市']
      },
      {
        n: '湘西土家族苗族自治州',
        c: [
          '吉首市',
          '泸溪县',
          '凤凰县',
          '花垣县',
          '保靖县',
          '古丈县',
          '永顺县',
          '龙山县'
        ]
      }
    ]
  },
  {
    n: '广东省',
    s: [
      {
        n: '广州市',
        c: [
          '荔湾区',
          '越秀区',
          '海珠区',
          '天河区',
          '白云区',
          '黄埔区',
          '番禺区',
          '花都区',
          '南沙区',
          '从化区',
          '增城区'
        ]
      },
      {
        n: '韶关市',
        c: [
          '武江区',
          '浈江区',
          '曲江区',
          '始兴县',
          '仁化县',
          '翁源县',
          '乳源瑶族自治县',
          '新丰县',
          '乐昌市',
          '南雄市'
        ]
      },
      {
        n: '深圳市',
        c: [
          '罗湖区',
          '福田区',
          '南山区',
          '宝安区',
          '龙岗区',
          '盐田区',
          '龙华区',
          '坪山区',
          '光明区'
        ]
      },
      {
        n: '珠海市',
        c: ['香洲区', '斗门区', '金湾区', '澳门大学横琴校区(由澳门实施管辖)']
      },
      {
        n: '汕头市',
        c: [
          '龙湖区',
          '金平区',
          '濠江区',
          '潮阳区',
          '潮南区',
          '澄海区',
          '南澳县'
        ]
      },
      {
        n: '佛山市',
        c: ['禅城区', '南海区', '顺德区', '三水区', '高明区']
      },
      {
        n: '江门市',
        c: [
          '蓬江区',
          '江海区',
          '新会区',
          '台山市',
          '开平市',
          '鹤山市',
          '恩平市'
        ]
      },
      {
        n: '湛江市',
        c: [
          '赤坎区',
          '霞山区',
          '坡头区',
          '麻章区',
          '遂溪县',
          '徐闻县',
          '廉江市',
          '雷州市',
          '吴川市'
        ]
      },
      {
        n: '茂名市',
        c: ['茂南区', '电白区', '高州市', '化州市', '信宜市']
      },
      {
        n: '肇庆市',
        c: [
          '端州区',
          '鼎湖区',
          '高要区',
          '广宁县',
          '怀集县',
          '封开县',
          '德庆县',
          '四会市'
        ]
      },
      {
        n: '惠州市',
        c: ['惠城区', '惠阳区', '博罗县', '惠东县', '龙门县']
      },
      {
        n: '梅州市',
        c: [
          '梅江区',
          '梅县区',
          '大埔县',
          '丰顺县',
          '五华县',
          '平远县',
          '蕉岭县',
          '兴宁市'
        ]
      },
      {
        n: '汕尾市',
        c: ['城区', '海丰县', '陆河县', '陆丰市']
      },
      {
        n: '河源市',
        c: ['源城区', '紫金县', '龙川县', '连平县', '和平县', '东源县']
      },
      {
        n: '阳江市',
        c: ['江城区', '阳东区', '阳西县', '阳春市']
      },
      {
        n: '清远市',
        c: [
          '清城区',
          '清新区',
          '佛冈县',
          '阳山县',
          '连山壮族瑶族自治县',
          '连南瑶族自治县',
          '英德市',
          '连州市'
        ]
      },
      {
        n: '东莞市',
        c: [
          '黄江镇',
          '桥头镇',
          '清溪镇',
          '洪梅镇',
          '高埗镇',
          '麻涌镇',
          '塘厦镇',
          '万江街道',
          '望牛墩镇',
          '道滘镇',
          '莞城街道',
          '企石镇',
          '樟木头镇',
          '东坑镇',
          '大岭山镇',
          '南城街道',
          '谢岗镇',
          '东城街道',
          '常平镇',
          '凤岗镇',
          '大朗镇',
          '寮步镇',
          '横沥镇',
          '沙田镇',
          '石排镇',
          '茶山镇',
          '中堂镇',
          '长安镇',
          '厚街镇',
          '虎门镇',
          '石碣镇',
          '石龙镇'
        ]
      },
      {
        n: '中山市',
        c: [
          '横栏镇',
          '小榄镇',
          '神湾镇',
          '古镇镇',
          '港口镇',
          '三乡镇',
          '石岐街道',
          '大涌镇',
          '阜沙镇',
          '西区街道',
          '沙溪镇',
          '东凤镇',
          '坦洲镇',
          '南头镇',
          '三角镇',
          '板芙镇',
          '民众街道',
          '黄圃镇',
          '南区街道',
          '东区街道',
          '南朗街道',
          '五桂山街道',
          '中山港街道'
        ]
      },
      {
        n: '潮州市',
        c: ['湘桥区', '潮安区', '饶平县']
      },
      {
        n: '揭阳市',
        c: ['榕城区', '揭东区', '揭西县', '惠来县', '普宁市']
      },
      {
        n: '云浮市',
        c: ['云城区', '云安区', '新兴县', '郁南县', '罗定市']
      }
    ]
  },
  {
    n: '广西壮族自治区',
    s: [
      {
        n: '南宁市',
        c: [
          '兴宁区',
          '青秀区',
          '江南区',
          '西乡塘区',
          '良庆区',
          '邕宁区',
          '武鸣区',
          '隆安县',
          '马山县',
          '上林县',
          '宾阳县',
          '横州市'
        ]
      },
      {
        n: '柳州市',
        c: [
          '城中区',
          '鱼峰区',
          '柳南区',
          '柳北区',
          '柳江区',
          '柳城县',
          '鹿寨县',
          '融安县',
          '融水苗族自治县',
          '三江侗族自治县'
        ]
      },
      {
        n: '桂林市',
        c: [
          '秀峰区',
          '叠彩区',
          '象山区',
          '七星区',
          '雁山区',
          '临桂区',
          '阳朔县',
          '灵川县',
          '全州县',
          '兴安县',
          '永福县',
          '灌阳县',
          '龙胜各族自治县',
          '资源县',
          '平乐县',
          '恭城瑶族自治县',
          '荔浦市'
        ]
      },
      {
        n: '梧州市',
        c: ['万秀区', '长洲区', '龙圩区', '苍梧县', '藤县', '蒙山县', '岑溪市']
      },
      {
        n: '北海市',
        c: ['海城区', '银海区', '铁山港区', '合浦县']
      },
      {
        n: '防城港市',
        c: ['港口区', '防城区', '上思县', '东兴市']
      },
      {
        n: '钦州市',
        c: ['钦南区', '钦北区', '灵山县', '浦北县']
      },
      {
        n: '贵港市',
        c: ['港北区', '港南区', '覃塘区', '平南县', '桂平市']
      },
      {
        n: '玉林市',
        c: ['玉州区', '福绵区', '容县', '陆川县', '博白县', '兴业县', '北流市']
      },
      {
        n: '百色市',
        c: [
          '右江区',
          '田阳区',
          '田东县',
          '德保县',
          '那坡县',
          '凌云县',
          '乐业县',
          '田林县',
          '西林县',
          '隆林各族自治县',
          '靖西市',
          '平果市'
        ]
      },
      {
        n: '贺州市',
        c: ['八步区', '平桂区', '昭平县', '钟山县', '富川瑶族自治县']
      },
      {
        n: '河池市',
        c: [
          '金城江区',
          '宜州区',
          '南丹县',
          '天峨县',
          '凤山县',
          '东兰县',
          '罗城仫佬族自治县',
          '环江毛南族自治县',
          '巴马瑶族自治县',
          '都安瑶族自治县',
          '大化瑶族自治县'
        ]
      },
      {
        n: '来宾市',
        c: ['兴宾区', '忻城县', '象州县', '武宣县', '金秀瑶族自治县', '合山市']
      },
      {
        n: '崇左市',
        c: [
          '江州区',
          '扶绥县',
          '宁明县',
          '龙州县',
          '大新县',
          '天等县',
          '凭祥市'
        ]
      }
    ]
  },
  {
    n: '海南省',
    s: [
      {
        n: '海口市',
        c: ['秀英区', '龙华区', '琼山区', '美兰区']
      },
      {
        n: '三亚市',
        c: ['海棠区', '吉阳区', '天涯区', '崖州区']
      },
      {
        n: '三沙市',
        c: ['西沙区', '南沙区']
      },
      {
        n: '儋州市',
        c: [
          '光村镇',
          '中和镇',
          '海头镇',
          '新州镇',
          '峨蔓镇',
          '三都镇',
          '那大镇',
          '排浦镇',
          '南丰镇',
          '白马井镇',
          '东成镇',
          '王五镇',
          '兰洋镇',
          '木棠镇',
          '雅星镇',
          '和庆镇',
          '大成镇'
        ]
      },
      {
        n: '五指山市',
        c: [
          '毛阳镇',
          '番阳镇',
          '水满乡',
          '毛道乡',
          '畅好乡',
          '通什镇',
          '南圣镇'
        ]
      },
      {
        n: '琼海市',
        c: [
          '长坡镇',
          '石壁镇',
          '龙江镇',
          '阳江镇',
          '会山镇',
          '博鳌镇',
          '塔洋镇',
          '潭门镇',
          '万泉镇',
          '大路镇',
          '嘉积镇',
          '中原镇'
        ]
      },
      {
        n: '文昌市',
        c: [
          '文教镇',
          '龙楼镇',
          '铺前镇',
          '东郊镇',
          '昌洒镇',
          '锦山镇',
          '文城镇',
          '重兴镇',
          '公坡镇',
          '冯坡镇',
          '东路镇',
          '抱罗镇',
          '会文镇',
          '东阁镇',
          '蓬莱镇',
          '翁田镇',
          '潭牛镇'
        ]
      },
      {
        n: '万宁市',
        c: [
          '后安镇',
          '和乐镇',
          '东澳镇',
          '山根镇',
          '龙滚镇',
          '北大镇',
          '三更罗镇',
          '礼纪镇',
          '大茂镇',
          '万城镇',
          '长丰镇',
          '南桥镇'
        ]
      },
      {
        n: '东方市',
        c: [
          '八所镇',
          '大田镇',
          '三家镇',
          '四更镇',
          '新龙镇',
          '感城镇',
          '板桥镇',
          '天安乡',
          '江边乡',
          '东河镇'
        ]
      },
      {
        n: '定安县',
        c: [
          '岭口镇',
          '龙门镇',
          '新竹镇',
          '定城镇',
          '雷鸣镇',
          '富文镇',
          '黄竹镇',
          '龙湖镇',
          '翰林镇',
          '龙河镇'
        ]
      },
      {
        n: '屯昌县',
        c: [
          '西昌镇',
          '南坤镇',
          '坡心镇',
          '南吕镇',
          '乌坡镇',
          '枫木镇',
          '屯城镇',
          '新兴镇'
        ]
      },
      {
        n: '澄迈县',
        c: [
          '老城镇',
          '大丰镇',
          '瑞溪镇',
          '中兴镇',
          '仁兴镇',
          '加乐镇',
          '金江镇',
          '福山镇',
          '桥头镇',
          '文儒镇',
          '永发镇'
        ]
      },
      {
        n: '临高县',
        c: [
          '博厚镇',
          '南宝镇',
          '和舍镇',
          '调楼镇',
          '东英镇',
          '加来镇',
          '临城镇',
          '多文镇',
          '波莲镇',
          '皇桐镇',
          '新盈镇'
        ]
      },
      {
        n: '白沙黎族自治县',
        c: [
          '南开乡',
          '阜龙乡',
          '细水乡',
          '打安镇',
          '青松乡',
          '七坊镇',
          '牙叉镇',
          '元门乡',
          '金波乡',
          '荣邦乡',
          '邦溪镇'
        ]
      },
      {
        n: '昌江黎族自治县',
        c: [
          '乌烈镇',
          '叉河镇',
          '石碌镇',
          '昌化镇',
          '王下乡',
          '十月田镇',
          '七叉镇',
          '海尾镇'
        ]
      },
      {
        n: '乐东黎族自治县',
        c: [
          '莺歌海镇',
          '佛罗镇',
          '黄流镇',
          '尖峰镇',
          '志仲镇',
          '大安镇',
          '万冲镇',
          '抱由镇',
          '千家镇',
          '九所镇',
          '利国镇'
        ]
      },
      {
        n: '陵水黎族自治县',
        c: [
          '椰林镇',
          '黎安镇',
          '新村镇',
          '文罗镇',
          '群英乡',
          '提蒙乡',
          '三才镇',
          '隆广镇',
          '英州镇',
          '本号镇',
          '光坡镇'
        ]
      },
      {
        n: '保亭黎族苗族自治县',
        c: [
          '南林乡',
          '毛感乡',
          '什玲镇',
          '保城镇',
          '六弓乡',
          '三道镇',
          '响水镇',
          '新政镇',
          '加茂镇'
        ]
      },
      {
        n: '琼中黎族苗族自治县',
        c: [
          '什运乡',
          '黎母山镇',
          '湾岭镇',
          '红毛镇',
          '和平镇',
          '中平镇',
          '上安乡',
          '吊罗山乡',
          '长征镇',
          '营根镇'
        ]
      }
    ]
  },
  {
    n: '重庆市',
    s: [
      {
        n: '重庆市',
        c: [
          '万州区',
          '涪陵区',
          '渝中区',
          '大渡口区',
          '江北区',
          '沙坪坝区',
          '九龙坡区',
          '南岸区',
          '北碚区',
          '綦江区',
          '大足区',
          '渝北区',
          '巴南区',
          '黔江区',
          '长寿区',
          '江津区',
          '合川区',
          '永川区',
          '南川区',
          '璧山区',
          '铜梁区',
          '潼南区',
          '荣昌区',
          '开州区',
          '梁平区',
          '武隆区',
          '城口县',
          '丰都县',
          '垫江县',
          '忠县',
          '云阳县',
          '奉节县',
          '巫山县',
          '巫溪县',
          '石柱土家族自治县',
          '秀山土家族苗族自治县',
          '酉阳土家族苗族自治县',
          '彭水苗族土家族自治县'
        ]
      }
    ]
  },
  {
    n: '四川省',
    s: [
      {
        n: '成都市',
        c: [
          '锦江区',
          '青羊区',
          '金牛区',
          '武侯区',
          '成华区',
          '龙泉驿区',
          '青白江区',
          '新都区',
          '温江区',
          '双流区',
          '郫都区',
          '新津区',
          '金堂县',
          '大邑县',
          '蒲江县',
          '都江堰市',
          '彭州市',
          '邛崃市',
          '崇州市',
          '简阳市'
        ]
      },
      {
        n: '自贡市',
        c: ['自流井区', '贡井区', '大安区', '沿滩区', '荣县', '富顺县']
      },
      {
        n: '攀枝花市',
        c: ['东区', '西区', '仁和区', '米易县', '盐边县']
      },
      {
        n: '泸州市',
        c: [
          '江阳区',
          '纳溪区',
          '龙马潭区',
          '泸县',
          '合江县',
          '叙永县',
          '古蔺县'
        ]
      },
      {
        n: '德阳市',
        c: ['旌阳区', '罗江区', '中江县', '广汉市', '什邡市', '绵竹市']
      },
      {
        n: '绵阳市',
        c: [
          '涪城区',
          '游仙区',
          '安州区',
          '三台县',
          '盐亭县',
          '梓潼县',
          '北川羌族自治县',
          '平武县',
          '江油市'
        ]
      },
      {
        n: '广元市',
        c: [
          '利州区',
          '昭化区',
          '朝天区',
          '旺苍县',
          '青川县',
          '剑阁县',
          '苍溪县'
        ]
      },
      {
        n: '遂宁市',
        c: ['船山区', '安居区', '蓬溪县', '大英县', '射洪市']
      },
      {
        n: '内江市',
        c: ['市中区', '东兴区', '威远县', '资中县', '隆昌市']
      },
      {
        n: '乐山市',
        c: [
          '市中区',
          '沙湾区',
          '五通桥区',
          '金口河区',
          '犍为县',
          '井研县',
          '夹江县',
          '沐川县',
          '峨边彝族自治县',
          '马边彝族自治县',
          '峨眉山市'
        ]
      },
      {
        n: '南充市',
        c: [
          '顺庆区',
          '高坪区',
          '嘉陵区',
          '南部县',
          '营山县',
          '蓬安县',
          '仪陇县',
          '西充县',
          '阆中市'
        ]
      },
      {
        n: '眉山市',
        c: ['东坡区', '彭山区', '仁寿县', '洪雅县', '丹棱县', '青神县']
      },
      {
        n: '宜宾市',
        c: [
          '翠屏区',
          '南溪区',
          '叙州区',
          '江安县',
          '长宁县',
          '高县',
          '珙县',
          '筠连县',
          '兴文县',
          '屏山县'
        ]
      },
      {
        n: '广安市',
        c: ['广安区', '前锋区', '岳池县', '武胜县', '邻水县', '华蓥市']
      },
      {
        n: '达州市',
        c: ['通川区', '达川区', '宣汉县', '开江县', '大竹县', '渠县', '万源市']
      },
      {
        n: '雅安市',
        c: [
          '雨城区',
          '名山区',
          '荥经县',
          '汉源县',
          '石棉县',
          '天全县',
          '芦山县',
          '宝兴县'
        ]
      },
      {
        n: '巴中市',
        c: ['巴州区', '恩阳区', '通江县', '南江县', '平昌县']
      },
      {
        n: '资阳市',
        c: ['雁江区', '安岳县', '乐至县']
      },
      {
        n: '阿坝藏族羌族自治州',
        c: [
          '马尔康市',
          '汶川县',
          '理县',
          '茂县',
          '松潘县',
          '九寨沟县',
          '金川县',
          '小金县',
          '黑水县',
          '壤塘县',
          '阿坝县',
          '若尔盖县',
          '红原县'
        ]
      },
      {
        n: '甘孜藏族自治州',
        c: [
          '康定市',
          '泸定县',
          '丹巴县',
          '九龙县',
          '雅江县',
          '道孚县',
          '炉霍县',
          '甘孜县',
          '新龙县',
          '德格县',
          '白玉县',
          '石渠县',
          '色达县',
          '理塘县',
          '巴塘县',
          '乡城县',
          '稻城县',
          '得荣县'
        ]
      },
      {
        n: '凉山彝族自治州',
        c: [
          '西昌市',
          '会理市',
          '木里藏族自治县',
          '盐源县',
          '德昌县',
          '会东县',
          '宁南县',
          '普格县',
          '布拖县',
          '金阳县',
          '昭觉县',
          '喜德县',
          '冕宁县',
          '越西县',
          '甘洛县',
          '美姑县',
          '雷波县'
        ]
      }
    ]
  },
  {
    n: '贵州省',
    s: [
      {
        n: '贵阳市',
        c: [
          '南明区',
          '云岩区',
          '花溪区',
          '乌当区',
          '白云区',
          '观山湖区',
          '开阳县',
          '息烽县',
          '修文县',
          '清镇市'
        ]
      },
      {
        n: '六盘水市',
        c: ['钟山区', '六枝特区', '水城区', '盘州市']
      },
      {
        n: '遵义市',
        c: [
          '红花岗区',
          '汇川区',
          '播州区',
          '桐梓县',
          '绥阳县',
          '正安县',
          '道真仡佬族苗族自治县',
          '务川仡佬族苗族自治县',
          '凤冈县',
          '湄潭县',
          '余庆县',
          '习水县',
          '赤水市',
          '仁怀市'
        ]
      },
      {
        n: '安顺市',
        c: [
          '西秀区',
          '平坝区',
          '普定县',
          '镇宁布依族苗族自治县',
          '关岭布依族苗族自治县',
          '紫云苗族布依族自治县'
        ]
      },
      {
        n: '毕节市',
        c: [
          '七星关区',
          '大方县',
          '金沙县',
          '织金县',
          '纳雍县',
          '威宁彝族回族苗族自治县',
          '赫章县',
          '黔西市'
        ]
      },
      {
        n: '铜仁市',
        c: [
          '碧江区',
          '万山区',
          '江口县',
          '玉屏侗族自治县',
          '石阡县',
          '思南县',
          '印江土家族苗族自治县',
          '德江县',
          '沿河土家族自治县',
          '松桃苗族自治县'
        ]
      },
      {
        n: '黔西南布依族苗族自治州',
        c: [
          '兴义市',
          '兴仁市',
          '普安县',
          '晴隆县',
          '贞丰县',
          '望谟县',
          '册亨县',
          '安龙县'
        ]
      },
      {
        n: '黔东南苗族侗族自治州',
        c: [
          '凯里市',
          '黄平县',
          '施秉县',
          '三穗县',
          '镇远县',
          '岑巩县',
          '天柱县',
          '锦屏县',
          '剑河县',
          '台江县',
          '黎平县',
          '榕江县',
          '从江县',
          '雷山县',
          '麻江县',
          '丹寨县'
        ]
      },
      {
        n: '黔南布依族苗族自治州',
        c: [
          '都匀市',
          '福泉市',
          '荔波县',
          '贵定县',
          '瓮安县',
          '独山县',
          '平塘县',
          '罗甸县',
          '长顺县',
          '龙里县',
          '惠水县',
          '三都水族自治县'
        ]
      }
    ]
  },
  {
    n: '云南省',
    s: [
      {
        n: '昆明市',
        c: [
          '五华区',
          '盘龙区',
          '官渡区',
          '西山区',
          '东川区',
          '呈贡区',
          '晋宁区',
          '富民县',
          '宜良县',
          '石林彝族自治县',
          '嵩明县',
          '禄劝彝族苗族自治县',
          '寻甸回族彝族自治县',
          '安宁市'
        ]
      },
      {
        n: '曲靖市',
        c: [
          '麒麟区',
          '沾益区',
          '马龙区',
          '陆良县',
          '师宗县',
          '罗平县',
          '富源县',
          '会泽县',
          '宣威市'
        ]
      },
      {
        n: '玉溪市',
        c: [
          '红塔区',
          '江川区',
          '通海县',
          '华宁县',
          '易门县',
          '峨山彝族自治县',
          '新平彝族傣族自治县',
          '元江哈尼族彝族傣族自治县',
          '澄江市'
        ]
      },
      {
        n: '保山市',
        c: ['隆阳区', '施甸县', '龙陵县', '昌宁县', '腾冲市']
      },
      {
        n: '昭通市',
        c: [
          '昭阳区',
          '鲁甸县',
          '巧家县',
          '盐津县',
          '大关县',
          '永善县',
          '绥江县',
          '镇雄县',
          '彝良县',
          '威信县',
          '水富市'
        ]
      },
      {
        n: '丽江市',
        c: ['古城区', '玉龙纳西族自治县', '永胜县', '华坪县', '宁蒗彝族自治县']
      },
      {
        n: '普洱市',
        c: [
          '思茅区',
          '宁洱哈尼族彝族自治县',
          '墨江哈尼族自治县',
          '景东彝族自治县',
          '景谷傣族彝族自治县',
          '镇沅彝族哈尼族拉祜族自治县',
          '江城哈尼族彝族自治县',
          '孟连傣族拉祜族佤族自治县',
          '澜沧拉祜族自治县',
          '西盟佤族自治县'
        ]
      },
      {
        n: '临沧市',
        c: [
          '临翔区',
          '凤庆县',
          '云县',
          '永德县',
          '镇康县',
          '双江拉祜族佤族布朗族傣族自治县',
          '耿马傣族佤族自治县',
          '沧源佤族自治县'
        ]
      },
      {
        n: '楚雄彝族自治州',
        c: [
          '楚雄市',
          '禄丰市',
          '双柏县',
          '牟定县',
          '南华县',
          '姚安县',
          '大姚县',
          '永仁县',
          '元谋县',
          '武定县'
        ]
      },
      {
        n: '红河哈尼族彝族自治州',
        c: [
          '个旧市',
          '开远市',
          '蒙自市',
          '弥勒市',
          '屏边苗族自治县',
          '建水县',
          '石屏县',
          '泸西县',
          '元阳县',
          '红河县',
          '金平苗族瑶族傣族自治县',
          '绿春县',
          '河口瑶族自治县'
        ]
      },
      {
        n: '文山壮族苗族自治州',
        c: [
          '文山市',
          '砚山县',
          '西畴县',
          '麻栗坡县',
          '马关县',
          '丘北县',
          '广南县',
          '富宁县'
        ]
      },
      {
        n: '西双版纳傣族自治州',
        c: ['景洪市', '勐海县', '勐腊县']
      },
      {
        n: '大理白族自治州',
        c: [
          '大理市',
          '漾濞彝族自治县',
          '祥云县',
          '宾川县',
          '弥渡县',
          '南涧彝族自治县',
          '巍山彝族回族自治县',
          '永平县',
          '云龙县',
          '洱源县',
          '剑川县',
          '鹤庆县'
        ]
      },
      {
        n: '德宏傣族景颇族自治州',
        c: ['瑞丽市', '芒市', '梁河县', '盈江县', '陇川县']
      },
      {
        n: '怒江傈僳族自治州',
        c: ['泸水市', '福贡县', '贡山独龙族怒族自治县', '兰坪白族普米族自治县']
      },
      {
        n: '迪庆藏族自治州',
        c: ['香格里拉市', '德钦县', '维西傈僳族自治县']
      }
    ]
  },
  {
    n: '西藏自治区',
    s: [
      {
        n: '拉萨市',
        c: [
          '城关区',
          '堆龙德庆区',
          '达孜区',
          '林周县',
          '当雄县',
          '尼木县',
          '曲水县',
          '墨竹工卡县'
        ]
      },
      {
        n: '日喀则市',
        c: [
          '桑珠孜区',
          '南木林县',
          '江孜县',
          '定日县',
          '萨迦县',
          '拉孜县',
          '昂仁县',
          '谢通门县',
          '白朗县',
          '仁布县',
          '康马县',
          '定结县',
          '仲巴县',
          '亚东县',
          '吉隆县',
          '聂拉木县',
          '萨嘎县',
          '岗巴县'
        ]
      },
      {
        n: '昌都市',
        c: [
          '卡若区',
          '江达县',
          '贡觉县',
          '类乌齐县',
          '丁青县',
          '察雅县',
          '八宿县',
          '左贡县',
          '芒康县',
          '洛隆县',
          '边坝县'
        ]
      },
      {
        n: '林芝市',
        c: [
          '巴宜区',
          '工布江达县',
          '米林市',
          '墨脱县',
          '波密县',
          '察隅县',
          '朗县'
        ]
      },
      {
        n: '山南市',
        c: [
          '乃东区',
          '扎囊县',
          '贡嘎县',
          '桑日县',
          '琼结县',
          '曲松县',
          '措美县',
          '洛扎县',
          '加查县',
          '隆子县',
          '错那市',
          '浪卡子县'
        ]
      },
      {
        n: '那曲市',
        c: [
          '色尼区',
          '嘉黎县',
          '比如县',
          '聂荣县',
          '安多县',
          '申扎县',
          '索县',
          '班戈县',
          '巴青县',
          '尼玛县',
          '双湖县'
        ]
      },
      {
        n: '阿里地区',
        c: [
          '普兰县',
          '札达县',
          '噶尔县',
          '日土县',
          '革吉县',
          '改则县',
          '措勤县'
        ]
      }
    ]
  },
  {
    n: '陕西省',
    s: [
      {
        n: '西安市',
        c: [
          '新城区',
          '碑林区',
          '莲湖区',
          '灞桥区',
          '未央区',
          '雁塔区',
          '阎良区',
          '临潼区',
          '长安区',
          '高陵区',
          '鄠邑区',
          '蓝田县',
          '周至县'
        ]
      },
      {
        n: '铜川市',
        c: ['王益区', '印台区', '耀州区', '宜君县']
      },
      {
        n: '宝鸡市',
        c: [
          '渭滨区',
          '金台区',
          '陈仓区',
          '凤翔区',
          '岐山县',
          '扶风县',
          '眉县',
          '陇县',
          '千阳县',
          '麟游县',
          '凤县',
          '太白县'
        ]
      },
      {
        n: '咸阳市',
        c: [
          '秦都区',
          '杨陵区',
          '渭城区',
          '三原县',
          '泾阳县',
          '乾县',
          '礼泉县',
          '永寿县',
          '长武县',
          '旬邑县',
          '淳化县',
          '武功县',
          '兴平市',
          '彬州市'
        ]
      },
      {
        n: '渭南市',
        c: [
          '临渭区',
          '华州区',
          '潼关县',
          '大荔县',
          '合阳县',
          '澄城县',
          '蒲城县',
          '白水县',
          '富平县',
          '韩城市',
          '华阴市'
        ]
      },
      {
        n: '延安市',
        c: [
          '宝塔区',
          '安塞区',
          '延长县',
          '延川县',
          '志丹县',
          '吴起县',
          '甘泉县',
          '富县',
          '洛川县',
          '宜川县',
          '黄龙县',
          '黄陵县',
          '子长市'
        ]
      },
      {
        n: '汉中市',
        c: [
          '汉台区',
          '南郑区',
          '城固县',
          '洋县',
          '西乡县',
          '勉县',
          '宁强县',
          '略阳县',
          '镇巴县',
          '留坝县',
          '佛坪县'
        ]
      },
      {
        n: '榆林市',
        c: [
          '榆阳区',
          '横山区',
          '府谷县',
          '靖边县',
          '定边县',
          '绥德县',
          '米脂县',
          '佳县',
          '吴堡县',
          '清涧县',
          '子洲县',
          '神木市'
        ]
      },
      {
        n: '安康市',
        c: [
          '汉滨区',
          '汉阴县',
          '石泉县',
          '宁陕县',
          '紫阳县',
          '岚皋县',
          '平利县',
          '镇坪县',
          '白河县',
          '旬阳市'
        ]
      },
      {
        n: '商洛市',
        c: [
          '商州区',
          '洛南县',
          '丹凤县',
          '商南县',
          '山阳县',
          '镇安县',
          '柞水县'
        ]
      }
    ]
  },
  {
    n: '甘肃省',
    s: [
      {
        n: '兰州市',
        c: [
          '城关区',
          '七里河区',
          '西固区',
          '安宁区',
          '红古区',
          '永登县',
          '皋兰县',
          '榆中县'
        ]
      },
      {
        n: '嘉峪关市',
        c: ['峪泉镇', '新城镇', '文殊镇', '钢城街道', '雄关街道']
      },
      {
        n: '金昌市',
        c: ['金川区', '永昌县']
      },
      {
        n: '白银市',
        c: ['白银区', '平川区', '靖远县', '会宁县', '景泰县']
      },
      {
        n: '天水市',
        c: [
          '秦州区',
          '麦积区',
          '清水县',
          '秦安县',
          '甘谷县',
          '武山县',
          '张家川回族自治县'
        ]
      },
      {
        n: '武威市',
        c: ['凉州区', '民勤县', '古浪县', '天祝藏族自治县']
      },
      {
        n: '张掖市',
        c: [
          '甘州区',
          '肃南裕固族自治县',
          '民乐县',
          '临泽县',
          '高台县',
          '山丹县'
        ]
      },
      {
        n: '平凉市',
        c: [
          '崆峒区',
          '泾川县',
          '灵台县',
          '崇信县',
          '庄浪县',
          '静宁县',
          '华亭市'
        ]
      },
      {
        n: '酒泉市',
        c: [
          '肃州区',
          '金塔县',
          '瓜州县',
          '肃北蒙古族自治县',
          '阿克塞哈萨克族自治县',
          '玉门市',
          '敦煌市'
        ]
      },
      {
        n: '庆阳市',
        c: [
          '西峰区',
          '庆城县',
          '环县',
          '华池县',
          '合水县',
          '正宁县',
          '宁县',
          '镇原县'
        ]
      },
      {
        n: '定西市',
        c: ['安定区', '通渭县', '陇西县', '渭源县', '临洮县', '漳县', '岷县']
      },
      {
        n: '陇南市',
        c: [
          '武都区',
          '成县',
          '文县',
          '宕昌县',
          '康县',
          '西和县',
          '礼县',
          '徽县',
          '两当县'
        ]
      },
      {
        n: '临夏回族自治州',
        c: [
          '临夏市',
          '临夏县',
          '康乐县',
          '永靖县',
          '广河县',
          '和政县',
          '东乡族自治县',
          '积石山保安族东乡族撒拉族自治县'
        ]
      },
      {
        n: '甘南藏族自治州',
        c: [
          '合作市',
          '临潭县',
          '卓尼县',
          '舟曲县',
          '迭部县',
          '玛曲县',
          '碌曲县',
          '夏河县'
        ]
      }
    ]
  },
  {
    n: '青海省',
    s: [
      {
        n: '西宁市',
        c: [
          '城东区',
          '城中区',
          '城西区',
          '城北区',
          '湟中区',
          '大通回族土族自治县',
          '湟源县'
        ]
      },
      {
        n: '海东市',
        c: [
          '乐都区',
          '平安区',
          '民和回族土族自治县',
          '互助土族自治县',
          '化隆回族自治县',
          '循化撒拉族自治县'
        ]
      },
      {
        n: '海北藏族自治州',
        c: ['门源回族自治县', '祁连县', '海晏县', '刚察县']
      },
      {
        n: '黄南藏族自治州',
        c: ['同仁市', '尖扎县', '泽库县', '河南蒙古族自治县']
      },
      {
        n: '海南藏族自治州',
        c: ['共和县', '同德县', '贵德县', '兴海县', '贵南县']
      },
      {
        n: '果洛藏族自治州',
        c: ['玛沁县', '班玛县', '甘德县', '达日县', '久治县', '玛多县']
      },
      {
        n: '玉树藏族自治州',
        c: ['玉树市', '杂多县', '称多县', '治多县', '囊谦县', '曲麻莱县']
      },
      {
        n: '海西蒙古族藏族自治州',
        c: [
          '格尔木市',
          '德令哈市',
          '茫崖市',
          '乌兰县',
          '都兰县',
          '天峻县',
          '海西蒙古族藏族自治州直辖'
        ]
      }
    ]
  },
  {
    n: '宁夏回族自治区',
    s: [
      {
        n: '银川市',
        c: ['兴庆区', '西夏区', '金凤区', '永宁县', '贺兰县', '灵武市']
      },
      {
        n: '石嘴山市',
        c: ['大武口区', '惠农区', '平罗县']
      },
      {
        n: '吴忠市',
        c: ['利通区', '红寺堡区', '盐池县', '同心县', '青铜峡市']
      },
      {
        n: '固原市',
        c: ['原州区', '西吉县', '隆德县', '泾源县', '彭阳县']
      },
      {
        n: '中卫市',
        c: ['沙坡头区', '中宁县', '海原县']
      }
    ]
  },
  {
    n: '新疆维吾尔自治区',
    s: [
      {
        n: '乌鲁木齐市',
        c: [
          '天山区',
          '沙依巴克区',
          '新市区',
          '水磨沟区',
          '头屯河区',
          '达坂城区',
          '米东区',
          '乌鲁木齐县'
        ]
      },
      {
        n: '克拉玛依市',
        c: ['独山子区', '克拉玛依区', '白碱滩区', '乌尔禾区']
      },
      {
        n: '吐鲁番市',
        c: ['高昌区', '鄯善县', '托克逊县']
      },
      {
        n: '哈密市',
        c: ['伊州区', '巴里坤哈萨克自治县', '伊吾县']
      },
      {
        n: '昌吉回族自治州',
        c: [
          '昌吉市',
          '阜康市',
          '呼图壁县',
          '玛纳斯县',
          '奇台县',
          '吉木萨尔县',
          '木垒哈萨克自治县'
        ]
      },
      {
        n: '博尔塔拉蒙古自治州',
        c: ['博乐市', '阿拉山口市', '精河县', '温泉县']
      },
      {
        n: '巴音郭楞蒙古自治州',
        c: [
          '库尔勒市',
          '轮台县',
          '尉犁县',
          '若羌县',
          '且末县',
          '焉耆回族自治县',
          '和静县',
          '和硕县',
          '博湖县'
        ]
      },
      {
        n: '阿克苏地区',
        c: [
          '阿克苏市',
          '库车市',
          '温宿县',
          '沙雅县',
          '新和县',
          '拜城县',
          '乌什县',
          '阿瓦提县',
          '柯坪县'
        ]
      },
      {
        n: '克孜勒苏柯尔克孜自治州',
        c: ['阿图什市', '阿克陶县', '阿合奇县', '乌恰县']
      },
      {
        n: '喀什地区',
        c: [
          '喀什市',
          '疏附县',
          '疏勒县',
          '英吉沙县',
          '泽普县',
          '莎车县',
          '叶城县',
          '麦盖提县',
          '岳普湖县',
          '伽师县',
          '巴楚县',
          '塔什库尔干塔吉克自治县'
        ]
      },
      {
        n: '和田地区',
        c: [
          '和田市',
          '和田县',
          '墨玉县',
          '皮山县',
          '洛浦县',
          '策勒县',
          '于田县',
          '民丰县'
        ]
      },
      {
        n: '伊犁哈萨克自治州',
        c: [
          '伊宁市',
          '奎屯市',
          '霍尔果斯市',
          '伊宁县',
          '察布查尔锡伯自治县',
          '霍城县',
          '巩留县',
          '新源县',
          '昭苏县',
          '特克斯县',
          '尼勒克县'
        ]
      },
      {
        n: '塔城地区',
        c: [
          '塔城市',
          '乌苏市',
          '沙湾市',
          '额敏县',
          '托里县',
          '裕民县',
          '和布克赛尔蒙古自治县'
        ]
      },
      {
        n: '阿勒泰地区',
        c: [
          '阿勒泰市',
          '布尔津县',
          '富蕴县',
          '福海县',
          '哈巴河县',
          '青河县',
          '吉木乃县'
        ]
      },
      {
        n: '石河子市',
        c: [
          '兵团一五二团',
          '红山街道',
          '向阳街道',
          '兵团一四四团',
          '东城街道',
          '老街街道',
          '石河子镇',
          '北泉镇',
          '新城街道'
        ]
      },
      {
        n: '阿拉尔市',
        c: [
          '玛滩镇',
          '花桥镇',
          '沙河镇',
          '托喀依乡',
          '青松路街道',
          '塔门镇',
          '南口街道',
          '金杨镇',
          '新井子镇',
          '兵团农一师沙井子水利管理处',
          '金银川镇',
          '甘泉镇',
          '昌安镇',
          '塔南镇',
          '新开岭镇',
          '幸福镇',
          '金银川路街道',
          '幸福路街道',
          '双城镇'
        ]
      },
      {
        n: '图木舒克市',
        c: [
          '海安镇',
          '唐驿镇',
          '前海街道',
          '喀拉拜勒镇',
          '齐干却勒街道',
          '金胡杨镇',
          '夏河镇',
          '永安镇',
          '永安坝街道'
        ]
      },
      {
        n: '五家渠市',
        c: [
          '梧桐镇',
          '人民路街道',
          '兵团一零一团',
          '蔡家湖镇',
          '青湖路街道',
          '军垦路街道'
        ]
      },
      {
        n: '北屯市',
        c: ['海川镇', '丰庆镇', '双渠镇', '北屯镇']
      },
      {
        n: '铁门关市',
        c: ['博古其镇', '双丰镇']
      },
      {
        n: '双河市',
        c: ['兵团八十九团', '博河镇', '双桥镇', '石峪镇', '双乐镇']
      },
      {
        n: '可克达拉市',
        c: ['长丰镇', '金屯镇', '都拉塔口岸', '苇湖镇', '榆树庄镇', '金梁镇']
      },
      {
        n: '昆玉市',
        c: ['老兵镇', '昆牧镇', '昆泉镇', '兵团二二四团']
      },
      {
        n: '胡杨河市',
        c: ['兵团一二九团', '兵团一三零团']
      },
      {
        n: '新星市',
        c: ['兵团红星四场', '兵团黄田农场', '兵团红星一场']
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/DistrictPicker/area/_zh.js